export const globalRouter = { router: null };
